import React, { Fragment } from 'react';
import LayoutOne from '../../layouts/LayoutOne';
import PageHeader from '../PageHeader';
import Seo from '../Seo';
import SectionTitle from '../SectionTitles/SectionTitle';
import AboutList from '../Skill/AboutList';
import Estimate from '../Estimate';

// Shared template for service landing pages (senior moving, large homes, white glove,
// storage). Each page provides copy; layout/styling reuses the site's existing sections
// so the pages match the rest of the design. Every page ends with the estimate form.
const ServicePage = ({ seoTitle, seoDescription, headerTitle, introTitle, intro, featuresTitle, features }) => {
  return (
    <Fragment>
      <Seo title={seoTitle} description={seoDescription} />
      <LayoutOne>
        <PageHeader
          bgImg={process.env.PUBLIC_URL + '/assets/images/page_bg.jpg'}
          title={headerTitle}
        />

        <section className="about-section">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-sm-12 about_bottom_warp">
                <div className="about_list">
                  <SectionTitle title={introTitle} />
                  {intro.map((paragraph, i) => (
                    <p key={i}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="our-skill section">
          <div className="container">
            <SectionTitle title={featuresTitle} />
            <div className="row">
              <div className="row about_list_warp">
                {features.map((feature, i) => (
                  <AboutList
                    key={i}
                    title={feature.title}
                    text={feature.text}
                    icon={feature.icon}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>

        <Estimate />
      </LayoutOne>
    </Fragment>
  );
};

export default ServicePage;
